import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { ARTICLES } from "@/pages/blog/articles";

export default function BlogPage() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-14 md:px-10" data-testid="blog-index">
      <p className="text-xs uppercase tracking-[0.25em] text-accent">Guides</p>
      <h1 className="mt-3 font-display text-4xl font-medium tracking-tight sm:text-5xl">
        <BookOpen className="mr-2 inline h-8 w-8" /> The Zuntria Playbook
      </h1>
      <p className="mt-4 max-w-2xl text-muted-foreground">
        Practical, no-fluff guides on getting clients, making money and executing in the UK — written for the diaspora hustle.
      </p>
      <div className="mt-10 space-y-5">
        {ARTICLES.map((a) => (
          <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
            className="group block rounded-2xl border border-border bg-card p-6 transition-colors hover:border-primary/40 md:p-8">
            <span className="rounded-full bg-accent/10 px-2.5 py-1 text-xs text-accent">{a.tag}</span>
            <h2 className="mt-3 font-display text-xl group-hover:text-primary md:text-2xl">{a.title}</h2>
            <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">{a.intro}</p>
            <p className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
              {new Date(a.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })} · {a.readTime}
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}
